import { render, staticRenderFns } from "./Guestbook.vue?vue&type=template&id=179dced6&scoped=true&"
import script from "./Guestbook.vue?vue&type=script&lang=ts&"
export * from "./Guestbook.vue?vue&type=script&lang=ts&"
import style0 from "./Guestbook.vue?vue&type=style&index=0&id=179dced6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179dced6",
  null
  
)

export default component.exports